import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';

export default class SearchFlexibilityBlock extends React.PureComponent {
    static propTypes = {
        updateFilters: PropTypes.func.isRequired,
        filters: PropTypes.object.isRequired
    };

    flexibilities = [1, 3, 7];

    onClick(flexibility) {
        return () => {
            if (this.props.filters.period && this.props.filters.period.from && this.props.filters.period.to) {
                const f = Object.assign({}, this.props.filters);
                f.period.flexibility = flexibility;
                this.props.updateFilters(f);
            }
        };
    }

    render() {
        if (
            this.props.filters.period &&
            this.props.filters.period.from &&
            this.props.filters.period.to &&
            !this.props.filters.period.flexibility
        ) {
            return (
                <div className="search-flexibility-block">
                    <div className="search-flexibility-block-illustration"></div>
                    <div>
                        <div className="search-flexibility-block-title">
                            {i18n.t('search:search-flexibility-block.title')}
                        </div>
                        <div className="search-flexibility-block-content">
                            {i18n.t('search:search-flexibility-block.content')}
                        </div>
                        <div className="search-flexibility-block-actions">
                            {(() =>
                                this.flexibilities.map((flexibility) => (
                                    <button
                                        className="btn btn-default"
                                        key={flexibility}
                                        onClick={this.onClick(flexibility)}
                                    >
                                        +/-{' '}
                                        {i18n.t('common:duration.day', {
                                            count: flexibility
                                        })}
                                    </button>
                                )))()}
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }
}
